import { Record } from "immutable";

export default Record({
  accessToken: "",
  refreshToken: "",
  expiresInDate: ""
});



// WEBPACK FOOTER //
// ./src/common/users/auth.js